import { FooterMenuListCombinedProps } from './types';

const usePresenter = (props: FooterMenuListCombinedProps): FooterMenuListCombinedProps => {
  return props;
};

export default usePresenter;
